"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderExpandIcon = RenderExpandIcon;
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _tableContext = require("../../Context/tableContext");
var _ValidationToolTip = _interopRequireDefault(require("../ValidationToolTip"));
var _FormRow = require("./FormRow2");
var _ykbUtils = require("ykb-utils");
var _Form = _interopRequireDefault(require("../../../Form"));
var _FormContext = require("../../../Form/FormContext");
var _Icon = _interopRequireDefault(require("../../../Icon"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var setInitialValues = function setInitialValues(_ref) {
  var dataIndex = _ref.dataIndex,
    original = _ref.original,
    form = _ref.form;
  var value = original[dataIndex];
  (0, _react.useEffect)(function () {
    var formValue = (0, _defineProperty2.default)({}, dataIndex, value);
    var mappedValue = _tableContext.eventHub.getState('mapValuesToForm')(formValue);
    form.current.setFieldsValue(mappedValue || formValue);
  }, [value]);
};
function shouldListenOnChange(input) {
  if (!input) {
    return false;
  }
  /*
    if (input && input.props) {
      if (input.props.prefixCls === 'ykb-select') {
        return true;
      }
    }
    */
  if (input.className) {
    /*
      // new date picker classname
      if (input.className.toString().includes('rc-picker-input')) {
        return true;
      }
      */
    // v3 picker
    if (input.className.toString().includes('-datepicker-input')) {
      return true;
    }
  }
  return false;
}
function ConnectedEditableRow(_ref2) {
  var form = _ref2.form,
    children = _ref2.children,
    formRef = _ref2.formRef;
  formRef.current = form;
  return /*#__PURE__*/React.createElement(_FormContext.FormProvider, {
    formContext: {
      form: form
    }
  }, /*#__PURE__*/React.createElement(_FormRow.TestContext.Provider, {
    value: formRef
  }, children));
}
var EditableFormRow = _Form.default.create()(ConnectedEditableRow);
var RenderInput = function RenderInput(props) {
  var column = props.column,
    isDisabled = props.isDisabled,
    row = props.row,
    undoText = props.undoText,
    rowKey = props.rowKey,
    setInnerValue = props.setInnerValue,
    children = props.children,
    isEditing = props.isEditing;
  var dataIndex = column.dataIndex,
    cellChangeTrigger = column.cellChangeTrigger,
    editable = column.editable,
    inputProps = column.inputProps;
  var original = row.original,
    id = row.id,
    index = row.index;
  var form = (0, _react.useRef)();
  var selectedCellRef = (0, _react.useRef)(null);
  var isCellMode = _tableContext.eventHub.getState('mode') === 'cell';
  var indexClass = id.replace(/[.]/g, '-');
  function save(_x, _x2) {
    return _save.apply(this, arguments);
  }
  function _save() {
    _save = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(key, rowValue) {
      var data, onCellChange, mode, setData, formRow, mappedValues, newValueForCell;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            data = _tableContext.eventHub.getState('data');
            onCellChange = _tableContext.eventHub.getState('onCellChange');
            mode = _tableContext.eventHub.getState('mode');
            setData = _tableContext.eventHub.getState('setData');
            _context4.next = 6;
            return form.current.validateFields();
          case 6:
            formRow = _context4.sent;
            mappedValues = _tableContext.eventHub.getState('mapValuesFromForm')(_objectSpread(_objectSpread({}, rowValue !== null && (0, _typeof2.default)(rowValue) === 'object' ? rowValue : formRow), {}, {
              key: key
            })) || []; //changed column item for tree data selection,
            newValueForCell = isCellMode ? Object.assign(original, rowValue) : null;
            if (!(isCellMode && onCellChange && newValueForCell)) {
              _context4.next = 12;
              break;
            }
            _context4.next = 12;
            return onCellChange(key, Object.keys(mappedValues)[0] || rowValue, newValueForCell);
          case 12:
            setInnerValue(rowValue[dataIndex]);
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _save.apply(this, arguments);
  }
  var onInputBlur = function onInputBlur() {
    if (_tableContext.eventHub.getState('editingKey') === rowKey && _tableContext.eventHub.getState('selectedDataIndex') === dataIndex) {
      _tableContext.eventHub.emit('setEditingKey&selectedDataIndex', null, null);
    }
  };
  var onBlur = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var validationHasError, formValue, value, listenOnChange;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            validationHasError = _tableContext.eventHub.getState('validationHasError');
            _context.prev = 1;
            _context.next = 4;
            return form.current.validateFields();
          case 4:
            formValue = _context.sent;
            value = formValue[dataIndex];
            listenOnChange = shouldListenOnChange(selectedCellRef.current);
            validationHasError.current = false;
            if (!listenOnChange && !cellChangeTrigger) {
              save(rowKey, (0, _defineProperty2.default)({}, dataIndex, value));
            }
            onInputBlur();
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            validationHasError.current = true;
            throw _context.t0;
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12]]);
    }));
    return function onBlur(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onClick = function onClick(e) {
    e.stopPropagation();
  };
  var onInputFocus = function onInputFocus() {
    _tableContext.eventHub.emit('update.submitingElementClassName', "editable-cell-".concat(indexClass, "-").concat(dataIndex));
  };
  var onChange = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var listenOnChange;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            listenOnChange = shouldListenOnChange(selectedCellRef.current);
            if (!(!listenOnChange && !cellChangeTrigger)) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            // TODO: Dataların sonradan yüklenmesi durumu icin eklendi,
            // Settimeout kaldırmak icin kontrol edilebilir.
            setTimeout(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
              var formValue, value;
              return _regenerator.default.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return form.current.validateFields();
                  case 2:
                    formValue = _context2.sent;
                    value = formValue[dataIndex];
                    save(rowKey, (0, _defineProperty2.default)({}, dataIndex, value));
                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            })), 0);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onChange() {
      return _ref4.apply(this, arguments);
    };
  }();
  var _inputRef = (0, _react.useRef)(null);

  // useEffect(() => {
  //   const formValue = {
  //     [dataIndex]: original[dataIndex],
  //   };
  //   const mappedValue = eventHub.getState("mapValuesToForm")(formValue);
  //   form.current.setFieldsValue(mappedValue || formValue);
  // }, [isEditing]);

  (0, _react.useEffect)(function () {
    if (isEditing) {
      var input = selectedCellRef === null || selectedCellRef === void 0 ? void 0 : selectedCellRef.current;
      if (input && typeof input.focus === 'function') input === null || input === void 0 ? void 0 : input.focus();
      var formValue = (0, _defineProperty2.default)({}, dataIndex, original[dataIndex]);
      var mappedValue = _tableContext.eventHub.getState('mapValuesToForm')(formValue);
      form.current.setFieldsValue(mappedValue || formValue);
    }
  }, [isEditing]);
  if (!(0, _ykbUtils.isNullOrUndefined)(editable) && editable && isEditing) {
    var _form$current;
    var undo = function undo() {
      form.current.setFieldsValue((0, _defineProperty2.default)({}, dataIndex, original[dataIndex]));
      onInputBlur();
    };
    var InputCoponent = _tableContext.eventHub.getState('getInput')(dataIndex, original, _objectSpread(_objectSpread({
      size: 'small',
      inputRef: function inputRef(ref) {
        if (ref) {
          _inputRef.current = ref;
          selectedCellRef.current = ref;
        }
        '';
      },
      ref: function ref(_ref6) {
        if (!_inputRef.current) {
          _inputRef.current = _ref6;
          selectedCellRef.current = _ref6;
        }
      }
    }, inputProps || {}), {}, {
      name: dataIndex,
      className: "editable-cell-".concat(rowKey, "-").concat(dataIndex, " ykb-table-input"),
      disabled: isDisabled,
      formRef: form,
      onBlur: onBlur,
      onFocus: onInputFocus,
      onChange: onChange,
      onClick: onClick,
      defaultOpen: true
      // getPopupContainer: (node) => {
      //   return node.parentNode.parentNode.parentNode.parentNode.parentNode
      //     .parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
      //     .parentNode.parentNode.parentNode.parentNode;
      // },
    }) // inputType => 'number' | 'text'
    );
    var errors = (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.getFieldError(dataIndex);
    return /*#__PURE__*/React.createElement(_ValidationToolTip.default, {
      errors: errors,
      undo: undo,
      undoText: undoText,
      placement: id % 2 === 0 ? 'bottom' : 'top'
    }, /*#__PURE__*/React.createElement(EditableFormRow, {
      formRef: form
    }, InputCoponent));
  }
  return children;
};
var _default = exports.default = RenderInput;
function RenderExpandIcon(props) {
  var isExpandedColumn = props.isExpandedColumn,
    expandable = props.expandable,
    hasChildren = props.hasChildren,
    cellIndex = props.cellIndex,
    expandIconColumnIndex = props.expandIconColumnIndex,
    prefixCls = props.prefixCls,
    record = props.record,
    rowIndex = props.rowIndex,
    rowKey = props.rowKey,
    isExpanded = props.isExpanded,
    isActiveFilter = props.isActiveFilter;
  if (!isExpandedColumn || !expandable || !hasChildren || cellIndex !== expandIconColumnIndex) {
    return null;
  }
  var className = "".concat(prefixCls, "-expanded-cell");
  var _eventHub$getState = _tableContext.eventHub.getState('expandable'),
    onExpand = _eventHub$getState.onExpand,
    expandIcon = _eventHub$getState.expandIcon;
  var handleClick = (0, _react.useCallback)(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5() {
    var nextExpandedStatus;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          nextExpandedStatus = !isExpanded;
          _context5.t0 = typeof onExpand === 'function';
          if (!_context5.t0) {
            _context5.next = 5;
            break;
          }
          _context5.next = 5;
          return onExpand(nextExpandedStatus, record);
        case 5:
          _tableContext.eventHub.emit("update.formrow.isexpanded.".concat(rowKey), nextExpandedStatus);
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  })));
  return /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: 4
    },
    className: "".concat(prefixCls, "-row-expand-icon"),
    onClick: handleClick
  }, expandIcon ? expandIcon(isExpanded) : /*#__PURE__*/React.createElement(_Icon.default, {
    name: isExpanded ? 'minus' : 'plus',
    size: 16
  }));
}